import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

interface AnimatedSectionProps {
  children: React.ReactNode;
  animation?: 'slide-up' | 'slide-in-left' | 'slide-in-right' | 'scale-in' | 'fade-in';
  delay?: number;
  className?: string;
}

const AnimatedSection: React.FC<AnimatedSectionProps> = ({
  children,
  animation = 'slide-up',
  delay = 0,
  className = '',
}) => {
  const { ref, isVisible } = useScrollAnimation();

  const getAnimationClass = () => {
    if (!isVisible) return 'opacity-0 translate-y-8';
    
    switch (animation) {
      case 'slide-up':
        return 'animate-slide-up';
      case 'slide-in-left':
        return 'animate-slide-in-left';
      case 'slide-in-right':
        return 'animate-slide-in-right';
      case 'scale-in':
        return 'animate-scale-in';
      case 'fade-in':
        return 'animate-fade-in';
      default:
        return 'animate-slide-up';
    }
  };

  const getDelayClass = () => {
    if (delay === 100) return 'animation-delay-100';
    if (delay === 200) return 'animation-delay-200';
    if (delay === 300) return 'animation-delay-300';
    if (delay === 400) return 'animation-delay-400';
    return '';
  };

  return (
    <div
      ref={ref}
      className={`transition-all duration-600 ${getAnimationClass()} ${getDelayClass()} ${className}`}
      style={{ animationDelay: delay ? `${delay}ms` : undefined }}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;